import { apiRequest } from './_tools';

export function fetchCountries() {
  return apiRequest('/api/countries')
    .catch(({ error }) => Promise.reject(error));
}

export function fetchCountryStates(countryName) {
  const countryNameEncoded = encodeURIComponent(countryName);
  return apiRequest(`/api/countries/${countryNameEncoded}/states`)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/countries.js
 **/